/* yourtheone — PDP tall sticky sidebar (PC >= 990px)
 * 右カラム（.product__column-sticky）がビューポートより高いとき、
 * sticky top を「100vh - カラム高さ - margin」に下げて
 * 「説明を最後まで読み切った時点でカラム下端が固定される」挙動にする。
 * カラム高さ < viewport のときは Dawn デフォルト（top: 3rem）のまま。
 * 高さ変化（タブ切替・バリアント変更・画像ロード・リサイズ）は ResizeObserver で追従。
 * モバイル(<990px)は挙動変更なし。アニメーション/transition は使わない。
 */
(function () {
  'use strict';

  var DESKTOP_MIN = 990;
  var BOTTOM_MARGIN = 32; /* カラム下端とviewport下端の間の余白(px) */
  var TOP_DEFAULT = 48; /* Dawn の top: 3rem 相当 */

  function setup(column) {
    if (column.dataset.ytStickyInit === 'true') return;
    column.dataset.ytStickyInit = 'true';

    var ro = null;

    function teardown() {
      /* エディタの section 再描画等で column がDOMから外れたら解放（リーク防止） */
      if (ro) ro.disconnect();
      window.removeEventListener('resize', update);
      window.removeEventListener('load', update);
    }

    function update() {
      if (!column.isConnected) {
        teardown();
        return;
      }
      if (window.innerWidth < DESKTOP_MIN) {
        column.style.removeProperty('--yt-sticky-top');
        return;
      }
      var columnHeight = column.offsetHeight;
      var viewportHeight = window.innerHeight;
      if (columnHeight + TOP_DEFAULT + BOTTOM_MARGIN > viewportHeight) {
        /* tall: 下端基準で固定（負の top になり得る） */
        column.style.setProperty(
          '--yt-sticky-top',
          viewportHeight - columnHeight - BOTTOM_MARGIN + 'px'
        );
      } else {
        /* short: 従来どおり上端 sticky */
        column.style.removeProperty('--yt-sticky-top');
      }
    }

    if ('ResizeObserver' in window) {
      /* 高さ変化（タブ切替・バリアント変更・画像ロード）に追従。
         update は軽量（読み取り1回＋CSS変数セット）なので同期実行で十分。
         rAF は hidden タブで発火しないため使わない。 */
      ro = new ResizeObserver(update);
      ro.observe(column);
    }
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }

  function init(root) {
    /* 対象は右の商品情報カラムのみ（media-gallery 側の product__column-sticky は Dawn 既定のまま） */
    var scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll('.product__info-container.product__column-sticky')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* テーマエディタ互換: セクション再描画時は外部scriptが再実行されないため再init */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
